module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar is-fixed-top",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    },
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "bd-special-shadow",
    staticStyle: {
      "opacity": "1",
      "transform": "scaleY(1)"
    },
    attrs: {
      "id": "specialShadow"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item a-login",
    on: {
      "click": function($event) {
        _vm.showUserContent = true
      }
    }
  }, [_c('span', {
    staticClass: "login",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-account"
  }), _vm._v(" " + _vm._s(this.Username))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showUserContent) ? _c('div', {
    staticClass: "usercontent panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_c('span', {
    staticClass: "title is-5 has-text-primary"
  }, [_vm._v("Account: " + _vm._s(this.Username))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "panel-block"
  }, [(_vm.ChangingPassword) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Password),
      expression: "Password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Password == ''),
      expression: "Password == ''"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red",
      "background-color": "white",
      "font-style": "italic"
    }
  }, [_vm._v(" Enter password")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Password2),
      expression: "Password2"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.Password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Password !== _vm.Password2),
      expression: "Password !== Password2"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red",
      "background-color": "white",
      "font-style": "italic"
    }
  }, [_vm._v("Passwords not equal")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "field"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.PassWordsValid
    },
    on: {
      "click": _vm.ResetPassword
    }
  }, [_vm._v("\n                      Reset Password\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.CloseChangingPassword
    }
  }, [_vm._v("\n                      Cancel\n                    ")])])])])]) : _vm._e(), _vm._v(" "), (!_vm.ChangingPassword) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "field"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.ChangingPassword = true
      }
    }
  }, [_vm._v("\n                    Change Password\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.CloseUserContent
    }
  }, [_vm._v("\n                    Close\n                  ")])])])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    attrs: {
      "target": "_blank",
      "title": "Logout"
    },
    on: {
      "click": _vm.Logout
    }
  }, [_c('i', {
    staticClass: "mdi mdi-logout mdi-18px mdi-dark"
  })]), _vm._v(" "), _c('button', {
    staticClass: "button navbar-burger is-flex-mobile",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "1.4rem"
    },
    attrs: {
      "src": require("../../assets/volleyball.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vue"
  }, [_vm._v("Volley")]), _c('span', {
    staticClass: "admin"
  }, [_vm._v("Admin3")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd406a0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = 291
// module chunks = 11